let api_url = '/api/';

if (process.env.NODE_ENV !== 'production') {
    api_url = 'https://zgody-makro-pl.ddev.site/api/';
}

export const API_CONFIG = {
    API_URL: api_url,
    LOG_REQUESTS: false
}
